// extracted by mini-css-extract-plugin
module.exports = {"tablesWrapper":"styles_tablesWrapper__6cl-w"};